import React, { useMemo } from 'react';
import DropDownSearchable from '../../dropDownSearchable';

const ProductVersionCard = ({ project, resourceOptions, onUpdate }) => {
    const {
        Project,
        init: { nta_version },
    } = project;
    const selectedProduct = Project?.home_product_id || null;
    const selectedNTAVersion = Project?.nta_version_id || null;
    const selectedProductVersion = Project?.product_version_id || null;

    const productOptions = useMemo(
        () =>
            resourceOptions?.home_products ? [...resourceOptions.home_products] : [],
        [resourceOptions?.home_products]
    );

    const ntaVersionOptions = useMemo(() => {
        const opts = [];
        Object.keys(nta_version).forEach((key) => {
            if (nta_version[key].home_product_id === selectedProduct) {
                opts.push({
                    label: nta_version[key].name,
                    value: nta_version[key].id,
                });
            }
        });
        opts.sort((a, b) =>
            a.label.localeCompare(b.label, undefined, { numeric: true })
        );
        return opts;
    }, [nta_version, selectedProduct]);

    const productVersionOptions = useMemo(
        () =>
            resourceOptions?.product_versions
                ? [...resourceOptions.product_versions]
                : [],
        [resourceOptions?.product_versions]
    );

    const findSelected = (val, opts) => {
        return opts.find((opt) => opt.value === val);
    };

    const handleSelectProduct = (selected) => {
        onUpdate([
            {
                sectionName: 'Project',
                fieldName: 'home_product_id',
                value: Number(selected.value),
            },
        ]);
    };

    const handleSelectNTAVersion = (selected) => {
        onUpdate([
            {
                sectionName: 'Project',
                fieldName: 'nta_version_id',
                value: Number(selected.value),
            },
        ]);
    };

    const handleSelectProductVersion = (selected) => {
        onUpdate([
            {
                sectionName: 'Project',
                fieldName: 'product_version_id',
                value: Number(selected.value),
            },
        ]);
    };

    return (
        <div>
            <div>
                <h3 className="col-5 cardTitle">Product Version</h3>
                <div className="d-flex justify-content-between align-items-center">
                    <label className="fieldLabel">Product Model:</label>
                    <div className="selectionContainer">
                        <DropDownSearchable
                            options={productOptions}
                            value={findSelected(selectedProduct, productOptions)}
                            onSelect={handleSelectProduct}
                            compact={true}
                        />
                    </div>
                </div>
                <div className="row mt-1 align-items-center ntaVersionContainer">
                    {!!selectedProduct && (
                        <>
                            <div className="mt-1 d-flex justify-content-between align-items-center">
                                <label className="fieldLabel">NTA Version:</label>
                                <div className="selectionContainer">
                                    <DropDownSearchable
                                        options={ntaVersionOptions}
                                        value={findSelected(selectedNTAVersion, ntaVersionOptions)}
                                        onSelect={handleSelectNTAVersion}
                                        sortOptions={false}
                                        disabled={selectedProduct === null}
                                        compact={true}
                                    />
                                </div>
                            </div>
                            <div className="mt-1 d-flex justify-content-between align-items-center">
                                <label className="fieldLabel">Product Version:</label>
                                <div className="selectionContainer">
                                    <DropDownSearchable
                                        options={productVersionOptions}
                                        value={findSelected(
                                            selectedProductVersion,
                                            productVersionOptions
                                        )}
                                        onSelect={handleSelectProductVersion}
                                        disabled={selectedProduct === null}
                                        compact={true}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductVersionCard;
